module.exports = __webpack_public_path__ + "static/media/44.de7a5925.jpg";